<template>
  <div>
    <div class="pull-left text-left col-12">
      <h5>
        {{ this.$t('reports.hts.reportTitle') }}
      </h5>
    </div>
    <div v-if="loading" class="loader">
      <b-spinner
        variant="primary"
        type="grow"
        :label="`${this.$t('reports.loadingLabel')}...`"
      ></b-spinner>
    </div>
    <div v-if="!loading" class="px-3 board-header">
      <div class="col-12" style="overflow: auto;">
        <div class="row mt-4 col-12">
          <b-table
            id="table-hts"
            :bordered="true"
            striped
            :items="items"
            :fields="fields"
            :per-page="limit"
            :current-page="currentPage"
          >
            <template #cell(topic)="{ item }">
              <div>{{ item.topic }}</div>
            </template>
            <template #cell(extraScore)="{ item }">
              <div>{{ item.extraScore }}</div>
            </template>
            <template #cell(totalScore)="{ item }">
              <div>{{ item.totalScore }}</div>
            </template>
            <template #cell(semiScore)="{ item }">
              <div>{{ item.semiScore }}</div>
            </template>
            <template #cell(totalSemi)="{ item }">
              <div>{{ item.totalSemi }}</div>
            </template>
            <template #cell(consolidedScore)="{ item }">
              <div>{{ item.consolidedScore }}</div>
            </template>
            <template #cell(totalConsolided)="{ item }">
              <div>{{ item.totalConsolided }}</div>
            </template>
          </b-table>
          <div class="pagination-area-action-list">
            <b-pagination
              v-model="currentPage"
              :total-rows="itemsTotal"
              :per-page="limit"
              aria-controls="table-hts"
            ></b-pagination>
          </div>

          <div class="col-12 mt-2 text-right">
            <a @click="exportToXLS" title="Exportar para XLS">
              <span class="xls">
                <i class="fas fa-file-excel"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapState } from 'vuex';
import loader from '@/components/atoms/loader';
import api from '../../../../services/api';
import Paginate from 'vuejs-paginate';
import XLSX from 'xlsx';
import * as moment from 'moment';

export default {
  name: 'ConversionDetails',
  components: {
    loader,
    Paginate,
  },

  data: () => ({
    loading: false,
    userAuth: null,
    fields: [],
    items: [],
    metaData: {
      totalSemi: 0,
      totalExtra: 0,
      totalConsolided: 0,
    },
    itemsTotal: 0,
    page: 1,
    filter: null,
    limit: 50,
    sortBy: null,
    sortDesc: null,
    currentPage: 1,
  }),

  computed: {
    ...mapState('authentication', ['userProfile']),
    ...mapState('actions', ['myActionId', 'actionGroupData', 'myActionsIds']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('companies', ['myMetric']),
    ...mapState('branches', ['myIh1', 'myIh2', 'myHierarchies1', 'myHierarchies2']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
  },

  watch: {
    actionGroupData: function watchActionGroup() {
      this.setData();
    },

    myActionId: function watchmyActionId() {
      this.setData();
    },

    myActionsIds: function watchmyActionsIds() {
      this.setData();
    },

    calendarDates: function watchCalendarDates() {
      this.setData()
    },

    myIh1: function watchMyIh1() {
      this.setData();
    },

    myHierarchies1: function watchMyHierarchies1(){
      this.setData();
    },

    myIh2: function watchMyIh2() {
      this.setData();
    },

    myHierarchies2: function watchMyHierarchies2(){
      this.setData();
    },

    myMetric: function watchMyMetric() {
      this.setData();
    },

    'indicatorData.value': function watchIndicatorDataValue() {
      this.setData();
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      await this.setData();
    },
  },

  methods: {
    async setData(){
      this.loading = true;

      this.items = [];

        this.fields = [
          {
            key: 'topic',
            label: 'TÓPICOS',
            sortable: true,
            class: ['categoryTh', 'color1'],
          },
          {
            key: 'extraScore',
            label: 'HTS EXTRA',
            sortable: true,
            class: ['categoryTh', 'alignTh', 'color2'],
          },
          {
            key: 'totalExtra',
            label: 'AMOSTRAS',
            sortable: true,
            class: ['categoryTh', 'alignTh', 'color2'],
          },
          {
            key: 'semiScore',
            label: 'HTS SEMI',
            sortable: true,
            class: ['categoryTh', 'alignTh', 'color3'],
          },
          {
            key: 'totalSemi',
            label: 'AMOSTRAS',
            sortable: true,
            class: ['categoryTh', 'alignTh', 'color3'],
          },
          {
            key: 'consolidedScore',
            label: 'HTS CONSOLIDADO',
            sortable: true,
            class: ['categoryTh', 'alignTh', 'color4'],
          },
          {
            key: 'totalConsolided',
            label: 'AMOSTRAS',
            sortable: true,
            class: ['categoryTh', 'alignTh', 'color4'],
          },
        ];

          const response = await api.get('/reports/hts', {
            headers: {
              'x-access-token': this.userAuth.token,
            },
            params: {
              actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
              startDate: this.calendarDates.start ? this.calendarDates.start : null,
              endDate: this.calendarDates.end ? this.calendarDates.end : null,
              ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
              ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
              metric: this.myMetric ? this.myMetric : null,
              groupId: this.actionGroupData._id,
              indicator: this.indicatorName,
              indicatorValue: this.indicatorData.value,
              indicatorRange: this.indicatorData.range,

            //   page: this.page,
            //   limit: this.limit,
            //   filter: this.filter,
            //   sortBy: this.sortBy,
            //   sortDesc: this.sortDesc,
            },
          });
          this.itemsTotal = response.data.htsData.length
          this.items = response.data.htsData;
          this.metaData = response.data.htsMetaData;

          this.loading = false;
    },
    handleSorting(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.setData();
    },
    dateFormat(param) {
      const date = moment(param).format('DD/MM/YYYY');
      return date
    },
    s2ab(s) {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      // eslint-disable-next-line
      for (let i = 0; i < s.length; i += 1) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    },
    exportToXLS() {
      const header = ['TÓPICO', 'HTS EXTRA', 'HTS SEMI', 'HTS CONSOLIDADO']

      const arr = []

      this.items.forEach((el)=>{
        arr.push({
        'TÓPICO': el.topic,
        'HTS EXTRA': el.extraScore,
        'HTS SEMI': el.semiScore,
        'HTS CONSOLIDADO': el.consolidedScore,
        })
      })

      const wb = XLSX.utils.book_new();
      wb.SheetNames.push('hts');
      const ws = XLSX.utils.json_to_sheet(arr, { header });

      // eslint-disable-next-line
      wb.Sheets['hts'] = ws;
      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
      const uri = window.URL.createObjectURL(
        new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }),
      );

      const link = document.createElement('a');
      link.href = uri;
      link.setAttribute('download', 'hts.xlsx');
      document.body.appendChild(link);
      link.click();
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
  },

  async mounted() {
    this.loading = true;
    await this.setData();
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
.loader {
  width: 100%;
  height: 350px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.xls {
  font-size: 35px;
  color: $primary;
  cursor: pointer;
}

.xls:hover {
  color: #1dc86e;
}

.pagination-area-action-list >>> a {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #4ce595;
  background-color: #fff;
  border: 1px solid #dee2e6;
}

.search-actions {
  display: flex;
  flex-direction: row;

  input {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }

  button {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }
}

@media (max-width: 1310px) {
  .summary {
    flex-direction: column;
  }
}
</style>
<style lang="scss">
.categoryTh {
  min-width: 50px !important;
}
.valueTh {
  min-width: 50px !important;
}
.alignTh {
  text-align: center !important;
}

.pagination-area-action-list .active a {
  text-decoration: none;
  z-index: 1;
  color: #fff;
  background-color: #4ce595;
  border-color: #4ce595;
}

.pagination-area-action-list a {
  outline: none;
}

.modal.fade .modal-dialog {
  height: 100%;
}
.color1, .color2, .color3, .color4 {
  color: #fff;
  font-size: 80%;
}
.color1 {
  color: #5E5E5E;
  background: #E8E8E8;
}
.color2 {
  background: #BABABA;
}
.color3 {
  background: #5E5E5E;
}
.color4 {
  background: #333333;
}
.table-bordered th, .table-bordered td {
    border: 1px solid #fff;
}

.table thead th {
    border-bottom: 2px solid #fff;
}

</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/mercedes-hts/index.vue